"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

//
//  Pill.tsx
//  Project-Lego
//
//  Created by Prian Kuhanandan on 12/06/19.
//  Copyright © 2019-present ContextLogic Inc. All rights reserved.
//

/* Lego Toolkit */
var propDoc = {
  title: {
    required: true,
    type: "string",
    description: "The text that appears within the pill"
  },
  selected: {
    required: true,
    type: "boolean",
    description: "Whether or not the pill is in selected state"
  },
  onChange: {
    required: true,
    type: "(selected: boolean) => mixed",
    description: "function to execute on change"
  }
};
var demoProps = {
  selected: true,
  title: "Category",
  onChange: function onChange() {}
};

var Pill = function Pill(props) {
  var styles = useStylesheet(props);
  var onChange = props.onChange,
      title = props.title,
      selected = props.selected,
      style = props.style,
      className = props.className;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.pill, style, className),
    onClick: function onClick() {
      return onChange(!selected);
    }
  }, title);
};

Pill.propDoc = propDoc;
Pill.demoProps = demoProps;

var _default = (0, _mobxReact.observer)(Pill);

exports["default"] = _default;

var useStylesheet = function useStylesheet(props) {
  var _useTheming = (0, _providers.useTheming)(),
      _useTheming$theme = _useTheming.theme,
      corePrimaryDarker = _useTheming$theme.corePrimaryDarker,
      corePrimaryDarkest = _useTheming$theme.corePrimaryDarkest,
      textWhite = _useTheming$theme.textWhite,
      textDark = _useTheming$theme.textDark,
      textBlack = _useTheming$theme.textBlack,
      surfaceLight = _useTheming$theme.surfaceLight,
      surfaceDark = _useTheming$theme.surfaceDark,
      surfaceDarker = _useTheming$theme.surfaceDarker,
      fonts = _useTheming.fonts;

  return (0, _react.useMemo)(function () {
    var selectedColor = props.blueScheme ? corePrimaryDarker : textDark;
    var selectedHoverColor = props.blueScheme ? corePrimaryDarkest : surfaceDarker;
    return _aphrodite.StyleSheet.create({
      pill: {
        height: 30,
        borderRadius: 18,
        borderWidth: 2,
        backgroundColor: props.selected ? selectedColor : surfaceLight,
        color: props.selected ? textWhite : textBlack,
        cursor: "pointer",
        fontFamily: fonts.medium,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "3px 20px",
        fontSize: "14px",
        minWidth: 45,
        ":hover": {
          backgroundColor: props.selected ? selectedHoverColor : surfaceDark
        }
      }
    });
  }, [props.blueScheme, props.selected, fonts.medium, surfaceDark, surfaceDarker, surfaceLight, textBlack, textDark, textWhite, corePrimaryDarker, corePrimaryDarkest]);
};